import { PromotionBalanceEntryQualifier } from '@gongxigames/framework/promotions';

export type PromotionData = {
    left: number;
    total: number;
    id: string;
    win: number;
    totalBet: number;
    totalPrice?: number;
    expirationTime?: string;
    rulesUrl?: string;
    type: PromotionBalanceEntryQualifier;
    isInUse: boolean;
    started: boolean;
};
